import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery } from 'react-query';
import { Box, Button, Typography } from '@mui/material';
import { useFamilyChild } from './FamilyShell';
import { parentApi } from './parentApi';

function timeAgo(iso) {
  if (!iso) return '';
  const d = new Date(iso);
  const mins = Math.round((Date.now() - d.getTime()) / 60000);
  if (mins < 60) return `${Math.max(1, mins)}m`;
  if (mins < 1440) return `${Math.round(mins / 60)}h`;
  return `${Math.round(mins / 1440)}d`;
}

export default function FamilyMessages() {
  const { child } = useFamilyChild();
  const navigate = useNavigate();
  const q = useQuery(
    ['familyMessages', child.studentId],
    async () => (await parentApi.messages(child.studentId)).data?.data || [],
    { enabled: !!child.studentId }
  );
  const contacts = useQuery(
    ['familyContacts', child.studentId],
    async () => (await parentApi.contacts(child.studentId)).data?.data,
    { enabled: !!child.studentId }
  );
  const rows = q.data || [];
  const c = contacts.data || {};

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 1 }}>Messages</Typography>
      {rows.map((t) => (
        <Box
          key={t.threadId}
          onClick={() => navigate(`/family/messages/${t.threadId}`)}
          sx={{ py: 1.5, borderBottom: '1px solid rgba(27,42,74,0.08)', cursor: 'pointer', display: 'flex', gap: 1 }}
        >
          <Box sx={{ flex: 1, minWidth: 0 }}>
            <Typography fontWeight={700} noWrap>{t.staffName} · {t.roleLabel}</Typography>
            <Typography variant="body2" color="text.secondary" noWrap>
              {t.statusLabel ? `${t.statusLabel} · ` : ''}{t.lastPreview}
            </Typography>
          </Box>
          <Typography variant="caption" color="text.secondary">{timeAgo(t.lastMessageAt)}</Typography>
        </Box>
      ))}

      <Typography variant="subtitle2" sx={{ mt: 3, mb: 1 }}>Start something new</Typography>
      {c.teacherName && (
        <Button fullWidth variant="outlined" sx={{ mb: 1, justifyContent: 'flex-start' }} onClick={() => navigate('/family/messages/new?channel=teacher')}>
          Ask {c.teacherName}
        </Button>
      )}
      {c.rmName && (
        <Button fullWidth variant="outlined" sx={{ mb: 1, justifyContent: 'flex-start' }} onClick={() => navigate('/family/messages/new?channel=rm')}>
          Ask {c.rmName}
        </Button>
      )}
      {c.rmName && (
        <Button fullWidth variant="outlined" sx={{ justifyContent: 'flex-start' }} onClick={() => navigate('/family/messages/new?channel=rm&threadType=complaint')}>
          Raise a complaint
        </Button>
      )}
      {!c.rmName && (
        <Typography color="text.secondary" variant="body2">
          We don't have a relationship manager on file yet.
        </Typography>
      )}
    </Box>
  );
}
